var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCross = function SvgIconCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.687 35.314a3 3 0 0 1 0-4.243l18.385-18.385a3 3 0 0 1 4.242 4.243L16.93 35.314a3 3 0 0 1-4.242 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M35.314 35.313a3 3 0 0 1-4.243 0L12.686 16.928a3 3 0 0 1 4.243-4.243L35.314 31.07a3 3 0 0 1 0 4.243"
  })));
};
export default SvgIconCross;